import React, { useState } from "react";
import style from "./Newsletter.module.css"
import { Link } from "react-router-dom";
const Newsletter = (props) =>{
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [show,setShow] = useState(false)
    const acEmail = document.querySelector("._x30961130 #email")
    const acButton = document.querySelector("#_form_19_submit")
    const handleInputChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email) {
            setError('Email is required');
            return;
        }
        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }else{
            setShow(true)
            console.log("Aaa")
            acEmail.value = email
            acButton.click()
        }

        // If validation passes, you can submit the form
        // For now, let's just log the email
        console.log(email);

        // Clear the email field and error message
        setEmail('');
        setError('');
    };

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };


    console.log(acEmail,acButton)
    return(
        <div className={`${style.newsletter} ${style[props.increase]} ${style[props.changeColor]}`}>
            <div className="container">
                 <div className={show ? style.showMessage : style.hideMessage }>
                 
                 

                  <div className={style.newsDis}>
                  <div>
                        <img src="/image/book.png"/>
                    </div>
                     <div>
                        <h4>Free Digital Unit Study</h4>
                     <h1>Introduction to Zoology!</h1>
                  <p className={style.newsText}>Get a taste of our unique approach to learning that makes science fun, accessible, and unforgettable!</p>
                  <form  onSubmit={handleSubmit}>
                    {/* <div> */}
                    <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleInputChange}
                    placeholder="Enter your email address"
                />
                        <button>Sign Up </button>
                    {/* </div> */}
                    {error && <p style={{ color: 'white' }}>{error}</p>}
                    <span>By clicking “Sign up,” you agree to our <Link to="/terms-of-service">Terms</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.</span>
                  </form>
                     </div>
                  </div>
                  <div class="_form_19"></div>
                 </div>
                  <div  className={`${style.submitMessage} ${show ?  style.hideMessage :style.showMessage}`}>
                    <h1>Yay! You're all signed up.😊</h1>
                  </div>
            </div>
        </div>
    )
}

export default Newsletter;